import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Heading, Kicker, Section } from './ui';
import { faqs } from '../../data/vcars';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="preguntas" className="bg-[#08090b]" data-id="element-12" data-mp="2ddukkkij9gra">
      <Kicker data-id="element-13" data-mp="2dc9pmtsb3vsw">Sin vueltas</Kicker>
      <Heading className="mt-4 text-white" data-id="element-14" data-mp="1zebpoteqg1wx">Preguntas frecuentes</Heading>

      <div className="mt-10 max-w-3xl" data-id="element-15" data-mp="24dy2j1qnfg57">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.q} className="border-t border-white/12" data-id="element-16" data-mp="1qf833fgcx4do" data-mpi={index}>
              <h3 data-id="element-17" data-mp="1ufi92s45fusj">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-18" data-mp="1uf08xked8wfc">
                  <span className="font-display text-lg font-bold text-white sm:text-xl" data-id="element-19" data-mp="3iqbfuep2shp3">
                    {faq.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-[#7f9bff] transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2.4} data-id="element-20" data-mp="3dqytdv249cn1" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-21" data-mp="2zrz54oiimzre">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-22" data-mp="2utxkw09csuec">
                    <p className="pb-5 pr-10 text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-23" data-mp="k0l0wofxlshz">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}